import React, { CSSProperties, useState } from "react";
import {
  Box,
  Button,
  Dropdown,
  getColor,
  Icons,
  Tooltip,
  Typography,
} from "fds";
import { t } from "i18next";
import UserSearchField from "../UserSearchField";
import utilsCommon from "../../shared/utils/common";
import "./index.scss";
import { UserDTO } from "../../types/adminDept";
import AdminUserSearchField from "../UserSearchField/AdminUserSearchField";
interface AdminUserSearchDropdownProps {
  classes?: string;
  style?: CSSProperties;
  buttonClick: number;
  filter: any;
  showValue?: boolean;
  isSingle?: boolean;
  users: UserDTO[];
  savedUsers: UserDTO[];
  workgroupId?: string;
  title?: string;
  isAllowNewUser?: boolean;
  isAllowEmptyUser?: boolean; // 빈값이어도 apply 활성화
  pageFrom?: "search" | "workgroupList" | "workgroupLog" | "fileLog";
  changeUsers: (iser: UserDTO[]) => void;
  changeFilterByKey: (key: string, val: any) => void;
  setButtonClick: (click: number) => void;
  buttonTitle?: string;
}

const AdminUserSearchDropdown: React.FC<AdminUserSearchDropdownProps> = ({
  filter,
  buttonClick,
  users,
  savedUsers,
  isSingle,
  workgroupId,
  isAllowNewUser = false,
  isAllowEmptyUser = false,
  title = t("common.oneMember"),
  buttonTitle = t("common.oneMember"),
  pageFrom = "workgroupList",
  setButtonClick,
  changeFilterByKey,
  changeUsers,
  classes,
  style,
}) => {
  const renderValue = () => {
    if (pageFrom === "search") {
      return users.filter((item) => item.id === filter.masterUserId).length > 0
        ? users.filter((item) => item.id === filter.masterUserId)[0].name ?? ""
        : "";
    } else if (pageFrom === "workgroupList") {
      return !filter.searchMemberIds || filter.searchMemberIds?.length > 0
        ? filter.searchMemberIds?.length + ""
        : "";
    } else if (pageFrom.includes("Log")) {
      const foundUser = users.filter((item) => item.id === filter.userId);
      return foundUser.length > 0
        ? foundUser[0].name
          ? foundUser[0].name
          : foundUser[0].id
        : undefined;
    }
    return "";
  };
  return (
    <Dropdown
      btnStyle="round"
      classes={"mg ml-12 userSearchDropdown"}
      placeholder={buttonTitle}
      btnSize="rd"
      buttonWidth={320}
      showValue
      value={renderValue()}
      buttonClick={buttonClick}
      onMountAction={() => changeUsers([...savedUsers])}
    >
      <Box height={26} alignItems="center">
        <Typography
          type="caption1_rg"
          classes="mg ml-8"
          exactColor={getColor("COLOR_TEXT_SECONDARY")}
        >
          {title}
        </Typography>
      </Box>
      <AdminUserSearchField
        width={"100%"}
        type="search"
        size="sm"
        hasFrontIcon
        disabled={isSingle ? users.length > 0 : false}
        isAllowNewUser={isAllowNewUser}
        dropdownWidth={288}
        workgroupId={workgroupId}
        dropdownHeight={388}
        classes="mg ml-8 mr-8 mb-8"
        onClick={(newUser) => {
          users.filter((item) => item.id === newUser?.id).length === 0 &&
            changeUsers(isSingle ? [newUser] : [...users, newUser]);
        }}
      />
      <Box classes="chips mg ml-8 overflow-scroll">
        {users.map((item) => (
          <Box>
            <Tooltip
              message={utilsCommon.getUserNameIdTag(item.id, item.name)}
              maxWidth={240}
            >
              <Typography type="body4_rg" ellipsis>
                {utilsCommon.getUserNameIdTag(item.id, item.name)}
              </Typography>
            </Tooltip>
            <Box
              classes="mg ml-4"
              onClick={() =>
                changeUsers(users.filter((item1) => item1.id !== item.id))
              }
            >
              <Icons
                variant={"line"}
                label={"closeLine"}
                size={20}
                classes="chips-close"
              />
            </Box>
          </Box>
        ))}
      </Box>
      <Box classes="workgrouplist-filter--bottom">
        <Button
          label={t("common.cancel")}
          type="secondary"
          btnStyle="fill"
          onClick={() => {
            setButtonClick(buttonClick + 1);
            changeUsers([...savedUsers]);
          }}
        />
        <Button
          label={t("common.apply")}
          classes="mg ml-10"
          btnStyle="fill"
          state={
            !isAllowEmptyUser &&
            (users.length === 0 ||
              (isSingle && users[0].id === filter.masterUserId))
              ? "disable"
              : "default"
          }
          onClick={() => {
            setButtonClick(buttonClick + 1);
            changeFilterByKey(
              pageFrom === "search"
                ? "masterUserId"
                : pageFrom.includes("Log")
                ? "userId"
                : "searchMemberIds",
              users.map((item) => item.id)
            );
          }}
        />
      </Box>
    </Dropdown>
  );
};
export default AdminUserSearchDropdown;
